import { render } from "./order_tracking.vue?vue&type=template&id=ce23b7f2"
import script from "./order_tracking.vue?vue&type=script&lang=js"
export * from "./order_tracking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__